import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M22.3775 5.53613C23.3524 4.82139 24.6775 4.81991 25.6532 5.53998L25.6773 5.55776L45.5356 21.7539C46.0688 22.1887 46.1556 22.9823 45.7294 23.5263C45.3032 24.0703 44.5254 24.1588 43.9922 23.7239L40.9999 21.2835V38.9278C40.9999 41.1481 38.8596 42.5 36.8408 42.5H11.159C9.14032 42.5 6.99994 41.1481 6.99994 38.9278V21.2866L4.00703 23.7244C3.47357 24.1589 2.69589 24.0699 2.27002 23.5257C1.84416 22.9814 1.93138 22.1879 2.46484 21.7534L22.3521 5.55476L22.3775 5.53613ZM24.1893 7.57307L38.5 19.2445L38.4999 19.25V38.9278C38.4999 39.2712 38.0338 40 36.8408 40H28.9999V30C28.9999 28.344 27.5066 27 25.6666 27H22.3333C20.4933 27 18.9999 28.344 18.9999 30V40H11.159C9.9661 40 9.49994 39.2712 9.49994 38.9278V19.2503L23.8361 7.57326C23.9434 7.50448 24.0853 7.50572 24.1893 7.57307Z';
var filledPath = 'M25.6532 5.53998C24.6776 4.81991 23.3525 4.82139 22.3776 5.53613L22.3522 5.55476L2.4649 21.7534C1.93144 22.1879 1.84422 22.9814 2.27008 23.5257C2.69595 24.0699 3.47363 24.1589 4.00709 23.7244L7 21.2866V38.9278C7 41.1481 9.14038 42.5 11.1591 42.5H19V30.1C19 28.3888 20.4933 27 22.3333 27H25.6667C27.5067 27 29 28.3888 29 30.1V42.5H36.8409C38.8596 42.5 41 41.1481 41 38.9278V21.2835L43.9923 23.7239C44.5255 24.1588 45.3032 24.0703 45.7294 23.5263C46.1556 22.9823 46.0689 22.1887 45.5357 21.7539L25.6773 5.55776L25.6532 5.53998Z';
var HomeAltIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
HomeAltIcon.displayName = 'HomeAltIcon';
HomeAltIcon.defaultProps = {
  'aria-label': 'Home'
};
export default HomeAltIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/HomeAltIcon/index.js
// module id = 1867
// module chunks = 12